import styled from '@emotion/styled';

export const STICKY_TABS_HEIGHT = 64;

export const ShopContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
`;

export const ShopScrollContent = styled.div`
  position: relative;
  flex: 1;
  overflow-y: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const TopDim = styled.div<{ $isShow: boolean; $hasTabs?: boolean }>`
  position: sticky;
  top: ${({ $hasTabs }) => ($hasTabs ? STICKY_TABS_HEIGHT : 0)}px;
  height: 24px;
  margin-bottom: -24px;
  pointer-events: none;
  z-index: 5;
  transition: opacity 0.1s;
  opacity: ${({ $isShow }) => ($isShow ? 1 : 0)};
  background: linear-gradient(180deg, ${({ theme }) => theme.color.bg2} 0%, transparent 100%);

  ${({ theme }) => theme.screenSize.mobile} {
    height: 24px;
    margin-bottom: -24px;
    background: linear-gradient(180deg, ${({ theme }) => theme.color.bg1} 0%, transparent 100%);
  }
`;

export const BottomDim = styled.div<{ $isShow: boolean }>`
  position: sticky;
  bottom: 0;
  height: 40px;
  margin-top: -40px;
  pointer-events: none;
  z-index: 5;
  transition: opacity 0.1s;
  opacity: ${({ $isShow }) => ($isShow ? 1 : 0)};
  background: linear-gradient(180deg, transparent 0%, ${({ theme }) => theme.color.bg2} 100%);

  ${({ theme }) => theme.screenSize.mobile} {
    height: 24px;
    margin-top: -24px;
    background: linear-gradient(180deg, transparent 0%, ${({ theme }) => theme.color.bg1} 100%);
  }
`;

export const DimTrigger = styled.div`
  width: 100%;
  height: 1px;
`;

export const StickyTabsWrapper = styled.div`
  position: sticky;
  top: 0;
  z-index: 10;
  background-color: ${({ theme }) => theme.color.bg2};

  ${({ theme }) => theme.screenSize.mobile} {
    background-color: ${({ theme }) => theme.color.bg1};
  }
`;

export const LegalSection = styled.div`
  padding: 8px 24px 32px;
`;

export const LegalList = styled.ul`
  margin: 0;
  padding-inline-start: 19.5px;
`;

export const LegalItem = styled.li`
  font-size: 13px;
  line-height: 16px;
  color: ${({ theme }) => theme.color.content6};
  margin: 0;
  padding: 0;

  & + & {
    margin-block-start: 10px;
  }

  a {
    color: inherit;
  }
`;

export const SectionListWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const SectionHeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
`;

export const SectionTitle = styled.p`
  font-size: 16px;
  font-weight: 700;
  line-height: 22px;
  color: ${({ theme }) => theme.color.content10};
  margin: 0;
`;
